import http from '@/utils/http.js'


export function  demoList(params){
    return http({
        url:'/public/demoList',
        method:'get',
        params:params
    })
}
export function  demoInfo(params){
    return http({
        url:'/public/demoInfo',
        method:'get',
        params:params
    })
}
export function  passwordLogin(params){
    return http({
        url:'/public/passwordLogin',
        method:'post',
        data:params
    })
}
export function  demoPut(params){
    return http({
        url:'/demo',
        method:'put',
        data:params
    })
}
export function  upload(params){
    return http({
        url:'/public/upload',
        method:'post',
        data:params
    })
}
export function  demoUpdate(params){
    return http({
        url:'/demo',
        method:'post',
        data:params
    })
}
